import { render, staticRenderFns } from "./TableSapProduct.vue?vue&type=template&id=874baed4"
import script from "./TableSapProduct.vue?vue&type=script&lang=js"
export * from "./TableSapProduct.vue?vue&type=script&lang=js"
import style0 from "./TableSapProduct.vue?vue&type=style&index=0&id=874baed4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports